.rail {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.sectionLabel {
  align-items: center;
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  min-height: 40px;
  padding: 0 var(--pgm-sys-spacing-4);
}

.item {
  align-items: center;
  border-radius: 9999px;
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  gap: var(--pgm-sys-spacing-3);
  min-height: 40px;
  outline: none;
  overflow: hidden;
  padding: 0 var(--pgm-sys-spacing-4);
  position: relative;
  text-decoration: none;
}

.item::before {
  background: var(--pgm-sys-color-on-surface-variant);
  border-radius: inherit;
  content: "";
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 0.15s ease;
}

.item:hover::before {
  opacity: 0.08;
}

.item:active::before {
  opacity: 0.1;
}

.item:hover,
.item:focus {
  color: var(--pgm-sys-color-on-surface-variant);
  text-decoration: none;
}

.item:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

.itemActive,
.itemActive:hover,
.itemActive:focus {
  background: var(--pgm-sys-color-secondary-container);
  color: var(--pgm-sys-color-on-secondary-container);
}

.itemActive::before {
  background: var(--pgm-sys-color-on-secondary-container);
}

.itemIcon {
  flex-shrink: 0;
  font-size: 24px;
  font-variation-settings:
    "FILL" 0,
    "wght" 400,
    "GRAD" 0,
    "opsz" 24;
}

.itemActive .itemIcon {
  font-variation-settings:
    "FILL" 1,
    "wght" 400,
    "GRAD" 0,
    "opsz" 24;
}

.itemLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
